/* @flow */

import { em } from 'polished';

import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    display: 'flex',

    marginBottom: 40,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',

    width: 30,
    marginRight: em(16, baseFontSize),

    stroke: ({ accentColor }: Object) => accentColor,
  },
  title: {
    marginTop: 0,

    color: ({ accentColor }: Object) => accentColor,

    fontWeight: 700,
    WebkitFontSmoothing: 'antialiased',
  },
};
